import {Pipe, PipeTransform} from '@angular/core';
import {ContactModel} from '../models/contact.model';

@Pipe({
    name: 'filterSerial'
})
export class FilterSerialPipe implements PipeTransform {

    transform(items: any, text: string): ContactModel[] {
        if (text.length === 0) {
            return items;
        }
        text = text.toLowerCase();
        return items.filter(item => {
            return item.serial.serialNo.toLowerCase().includes(text);
        });
    }

}
